import React from 'react';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';

export default props => {
  return (
    <React.Fragment>
      <DialogTitle id="max-width-dialog-title">
        DH Stock Balance Lifting
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          X, Y, Z where, <br />
          X = Sum of all DH max stock for today <br />
          Y = Sum of all DH current balance and <br />Z = Sum of all DH Bank
          Cash-in for today
        </DialogContentText>
      </DialogContent>
    </React.Fragment>
  );
};
